export const MIC_INPUT_CHANGE = "MIC_INPUT_CHANGE";
export const MIC_AUDIO_DETECTED = "MIC_AUDIO_DETECTED";
export const MIC_AUDIO_STATUS = "MIC_AUDIO_STATUS";
export const MIC_ACCESS_ALLOWED = "MIC_ACCESS_ALLOWED";
